export const BREAKPOINTS = {
    medium: `max-width:950px`,
    burger: `max-width:850px`,
    small: `max-width:550px`,
    phone: `max-width:470px`,
    extra_small: `max-width:360px`,
}

export const SCROLL_BEHAVIOUR = {
    behavior: 'smooth',
    block: "center",
    inline: "nearest"
}

export const TYPING_ERROR_STATES = {
    CORRECT: 'corrected',
    UNCORRECT: 'uncorrected'
}

export const PORTFOLIO_LINK = "https://pawlaczenko.github.io/";